import React, { useState } from "react";
import { Row, Col, Form, Button, Modal, Alert } from "react-bootstrap";
import { Progress } from "antd";

const ProfileProgress = (props) => {
    
  const { percentProgress } = props;

  return (
    <div className="card border-0 pb-0">
      <div className="card-body flex-wrap border-0 pb-0">
        <Row>
          <Col>
            <p className="profile-completion-text fs-16 font-weight-bold">
              Complete Your Profile
            </p>
            <p className="profile-completion-sub-text fs-14">
              Edit and fill the data required for profile completion.
            </p>
          </Col>
          <Col>
            <div className="pull-right mt-2 mb-5">
              <Progress
                type="circle"
                percent={percentProgress}
                width={80}
                strokeColor={{
                  "0%": "#07674e",
                  "100%": "#87d068",
                }}
              />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ProfileProgress;
